module.exports = __webpack_public_path__ + "img/hero_buyer.f4100ae4.png";